export default __webpack_public_path__ + "f43493d6d2ee12ab4b84f068e4fe565d.svg";